import React, { useEffect, useState } from 'react';

import { Menu, Dropdown, Button} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import './select-empresa.css'

import {useEmpresas} from '../../hooks';



const SelectEmpresa = () => {
       const [empresas, setEmpresas] = useState([]);
       const [empresaSelecionada, setEmpresaSelecionada] = useState({id:0});
       const {listaEmpresas, salvaSelecaoEmpresa, getEmpresaSelecionada} = useEmpresas();

       useEffect(()=>{
           
           listaEmpresas(setEmpresas);
           // eslint-disable-next-line react-hooks/exhaustive-deps
       }, []);

       useEffect(() => {
            getEmpresaSelecionada(setEmpresaSelecionada);
            // eslint-disable-next-line react-hooks/exhaustive-deps
       }, []);

       const renderListaEmpresas = (empresas) => {
            const arrEmpresasRenderizadas = []
            if(empresas && empresas.length){

                empresas.forEach(empresa => {
                    arrEmpresasRenderizadas.push(renderEmpresa(empresa));
                });
            }
            return arrEmpresasRenderizadas;
       }

       const empresaHandleClick = (empresa) => (evt) => {
            setEmpresaSelecionada(empresa);
            salvaSelecaoEmpresa(empresa);
            setTimeout(() => {
                window.location.reload();
            }, 200)
       }

       const renderDescricaoEmpresa = () => {
           if(empresaSelecionada.id > 0) {
               
           return (<><span className="identificador">{empresaSelecionada.id}</span>{empresaSelecionada.dados.razaoSocial}</>);
               
           }
           return (<>Selecione uma Empresa</>);
           
       }

       const renderEmpresa = (empresa) => {
            empresa.id = empresa.idEmpresa;
            const key  = "sel_empresa_"+ empresa.id;
            return(
                <Menu.Item key={key} className="menu-empresas" onClick={empresaHandleClick(empresa)}>
                    <span className='destaque'>{empresa.dados.nomeFantasia}</span>
                    <span>{empresa.dados.razaoSocial}</span>
                    <span>{empresa.dados.cnpj}</span>
                </Menu.Item>
            )
        }
    
    
        
        return(<div>
            
        <Dropdown overlay={
            <Menu>
                {renderListaEmpresas(empresas)}
            </Menu>}
        >
            <Button>
                {renderDescricaoEmpresa()} <DownOutlined />
            </Button>
        </Dropdown>
        </div>);
    
}

export {SelectEmpresa};